//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import area from'./address.js'
import { Message } from 'element-ui'
export default {
  data() {
    return {
      provincial:'',
      provincialList:[],
      city:'',
      cityList:[],
      district:'',
      districtList:[],
      purchasingStatus:'选择业务经理',
      purchasingStatusList:[],
      areaData:area,
      shopAddress:'',
      linkman:'',
      shopPhone:'',
      res:{},
      shopName:'',
      shopId:""
    }
  },
  created(){
      this.info()
  },
  methods: {
    info(){
      // let data = {
      //   pageNo:1,
      //   pageSize:1,
      //   shopType:1,
      //   dealerId:window.sessionStorage.getItem('dealerId')
      // }
      // // 加载业务经理列表
      // this.$axios.post('/mtea/stock/dealer/indexSearch', data).then(res => {
      //   this.purchasingStatusList = res.staffs
      //   // this.purchasingStatusList.unshift({dStaffId:'选择业务经理',dStaffName:'选择业务经理'})
      // })
      this.res = {provincial: '',provincialId: '',city: '',cityId: '',district: '',districtId: ''}
      // let msg = JSON.parse(window.sessionStorage.getItem('rowData'))
      let param = {
        dealerId:window.sessionStorage.getItem('dealerId'),
        dShopId:this.$route.query.shopId
      }      
      this.$axios.post('/mtea/stock/dealer/getShopInfo',param).then(msg=>{
        console.log(msg)
        this.shopId = msg.dShopId
        this.res.provincial = msg.dShopProvince
        this.res.city = msg.dShopCity
        this.res.district = msg.dShopArea
        console.log(this.res)
        for(let i = 0;i<this.areaData.length;i++){
          if(this.areaData[i].TopID === 0){
            this.provincialList.push(this.areaData[i]) 
            if(this.areaData[i].AddName === this.res.provincial)
            this.res.provincialId = this.areaData[i].ID
          }
          if(this.res.provincialId !== -1 && this.areaData[i].TopID === this.res.provincialId){
            this.cityList.push(this.areaData[i])
            if(this.areaData[i].AddName === this.res.city)
            this.res.cityId = this.areaData[i].ID
          }
          if(this.res.cityId !== -1 && this.areaData[i].TopID === this.res.cityId)
            this.districtList.push(this.areaData[i])
            if(this.areaData[i].AddName === this.res.district)
            this.res.districtId = this.areaData[i].ID
        }
        console.log(this.res)
        this.provincial = this.res.provincialId
        this.city = this.res.cityId
        this.district = this.res.districtId
        this.shopAddress= msg.dShopAddress
        this.linkman= msg.dShopLinkman
        this.shopPhone= msg.dShopPhone
        this.shopName = msg.dShopName
        this.purchasingStatusList = msg.dStaffs
        for(let i = 0; i<msg.dStaffs.length; i++){
          if(msg.dStaffs[i].dStaffId === msg.dStaffId){
            this.purchasingStatus = msg.dStaffId
            console.log(1234)
            break;
          }
        }          
      }) 
    },
    changeProvincial(ID){
      console.log(ID)
      this.city = ''
      this.cityList = []
      this.district = ''
      this.districtList = []
      for(let i = 0;i<this.areaData.length;i++){
        if(this.areaData[i].TopID === ID)
        this.cityList.push(this.areaData[i])
        if(this.areaData[i].TopID > ID) break
      } 
    },
    changeCity(ID){
      this.district = ''
      this.districtList = []
      for(let i = 0;i<this.areaData.length;i++){
        if(this.areaData[i].TopID === ID)
        this.districtList.push(this.areaData[i])
        if(this.areaData[i].TopID > ID) return
    } 
    },
    changeDistrict(ID){
      console.log(ID)
      this.districtList.forEach(e=>{
        if(e.ID === ID)
        this.res.district = e.AddName
      })
    },
    clickFun(){
      if(this.shopName === ''){
        this.$message('请输入店铺名！');
        return
      }
      if(this.purchasingStatus === '选择业务经理'){
        this.$message('请选择业务经理！');
        return
      }
      let data = {
        DShopProvince:this.res.provincial,
        DShopArea:this.res.district,
        DShopCity:this.res.city,
        DShopAddress:this.shopAddress,
        DShopLinkman:this.linkman,
        DShopName:this.shopName,
        DShopPhone:this.shopPhone,
        DStaffId:this.purchasingStatus,
        dealerId:window.sessionStorage.getItem('dealerId'),
        DShopId:this.shopId
      }
      console.log(data)
      this.$axios.post('/mtea/stock/dealer/addShop',data).then(()=>{
        this.$message({
          message: '保存成功',
          type: 'success'
        });
        this.$router.push({name:'homePage'})
      })
    }
  },
}
